// Lib
import { useEffect } from 'react';

const VIEWPORT_HEIGHT_UNIT_RATIO = 0.01;

const setViewportHeightUnit = () => {
  const vh = window.innerHeight * VIEWPORT_HEIGHT_UNIT_RATIO;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

// The trick to viewport units on mobile: mobile browsers count the address bar
// into 100vh, so we track the real viewport height in a CSS var instead.
const useModalViewportHeight = () => {
  useEffect(() => {
    setViewportHeightUnit();
    window.addEventListener('resize', setViewportHeightUnit);

    return () => window.removeEventListener('resize', setViewportHeightUnit);
  }, []);
};

export default useModalViewportHeight;
